<template>
    <!-- 3D Viewer popup -->

    <div>

    </div>
</template>

<script>
  export default {
    name: "Editoe3d"
  }
</script>

<style scoped>

</style>
